<template lang="html">
  <d-container fluid class="main-content-container px-3">
    <d-form>
      <d-form-row>
        <!-- User -->
        <d-col sm="10" class="form-group">
          <label for="name">
            Usuários
          </label>
          <d-form-input
            type="text"
            placeholder="E-mail"
            v-model="user.email"
          />
        </d-col>
        <d-col sm="2" class="form-group">
          <label class="d-block pt-4"></label>
          <d-button size="sm" class="d-inline btn-success" @click.prevent="attachUser()">
            Adicionar
          </d-button>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-list-group flush class="list-group-small col-10">
          <d-list-group-item v-for="(user, index) in model" :key="index" class="d-flex py-2 pr-0">
            <d-row class="w-100 align-items-center">
              <d-col cols="5">{{ user.name }}</d-col>
              <d-col cols="5">{{ user.email }}</d-col>
              <d-col cols="2 pr-0 text-right">
                <d-button size="sm" class="btn-danger" @click.prevent="detachUser(user)">Delete</d-button>
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-form-row>
    </d-form>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ResellerService from '_services/rest/modules/reseller';
import { _SAVE_MODEL_ } from '../../user/components/UserModel';

export default {
  name: 'reseller-users',
  props: {
    model: {
      type: Array,
      default: () => [],
    },
    resellerId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      user: {
        id: null,
        name: null,
        email: null,
      },
    };
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    attachUser() {
      ResellerService.attachResellerUser(this.resellerId, this.user.email)
        .then(response => {
          this.success(response, 'Usuário salvo com sucesso');
          this.user.email = null;
        })
        .catch(error => this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' }));
    },
    detachUser(user) {
      ResellerService.detachResellerUser(this.resellerId, user.id)
        .then(response => {
          this.success(response, 'Usuário removido com sucesso');
        });
    },
    saveUser(user) {
      this.user.email = user.email;
    },
    success(response, message) {
      this.$emit('updateUser', response.users);
      this.activeAlert({ message, theme: 'success' });
    },
  },
  mounted() {
    Events.$on(_SAVE_MODEL_, user => {
      this.saveUser(user);
      this.attachUser();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}
</style>
